<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-row-mehrspaltig-2-elemente">
    <mat-form-field appearance="fill" class="ktbl-input-box">
        <mat-label>Preisstand
            <i class="fas fa-info-circle ml-1 ktbl-icon-info-select" matTooltipClass="tooltip-format"
                matTooltip="Der Preisstand, der für die Berechnungen Baukost genutzt werden soll."
                [matTooltipPosition]="position.value" [matTooltipClass]="['tooltip-format', position.value]"></i>
        </mat-label>

        <mat-select required disableRipple [formControl]="preisstandFormControl" (selectionChange)="onValueChange()"
            panelClass="ktbl-large-select-panel">
            >
            <mat-option *ngFor="let preisstand of localService.preisstandList.value!" [value]="preisstand.preisstand">
                {{ preisstand.preisstand }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="ktbl-input-box" appearance="fill">
        <mat-label>Preisfaktor
            <i class="fas fa-info-circle ml-1 ktbl-icon-info-select" matTooltipClass="tooltip-format" matTooltip="Der Faktor, mit dem die Preise verändert werden sollen:
      1 = keine Änderung
      0,8 = Verringerung um 20% auf 80%
      1,3 = Erhöhung um 30% auf 130%" [matTooltipPosition]="position.value"
                [matTooltipClass]="['tooltip-format', position.value]"></i></mat-label>

        <input matInput required [errorStateMatcher]="matcher" [formControl]="preisfaktorFormControl"
            (input)="onValueChange()" />
        <mat-error *ngIf="preisfaktorFormControl.hasError('required')">
            Es wird ein Preisfaktor benötigt.
        </mat-error>
        <mat-error *ngIf="preisfaktorFormControl.hasError('pattern')">
            {{ formControlNumberFormatWarningGanzZahlLaeng2OderKomma2Text }}
        </mat-error>
    </mat-form-field>
</div>

<div class="ktbl-spacer-top-bottom"></div>

<table mat-table [dataSource]="dataSourceKge" class="ktbl-table-breite-komplett">
    <ng-container *ngFor="let column of displayedColsKge; let j = index" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{
                'ktbl-table-header-base-links': j === 0,
                'ktbl-table-header-base-rechts': j === displayedColsKge.length - 1,
                'ktbl-table-header-base-neutral': j !== 0 && j !== displayedColsKge.length - 1,
                'ktbl-table-header-typografie': true,
                'ktbl-table-allgemein-200-width': column === 'NUTZUNGSDAUER' || column === 'KGE',
                'ktbl-select-width': column === 'SELECTED'  
            }" [attr.colspan]="column === 'KGE' ? 2 : null">
            <ng-container *ngIf="column === 'SELECTED'">
                <mat-checkbox *ngIf="showAllSelected" [checked]="isAllSelected"
                    (change)="changeSelectAll($event.checked)">
                </mat-checkbox>
            </ng-container>

            <ng-container *ngIf="column === 'NUTZUNGSDAUER'">Nutzungsdauer</ng-container>
            <ng-container *ngIf="column === 'KGE'">{{ column.startsWith("KGE") ?
                "Kostengliederung nach DIN 276" : "" }}</ng-container>
        </th>

        <td mat-cell *matCellDef="let entry; let i= index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-center ktbl-table-cell-no-padding-left': column === 'SELECTED',
            'ktbl-table-cell-left': column === 'KGE' || column === 'BEZEICHNUNG' || column === 'NUTZUNGSDAUER',
            'ktbl-table-allgemein-200-width': column === 'KGE'
        }">
            <ng-container *ngIf="column === 'SELECTED'"><mat-checkbox [checked]="entry.isSelected"
                    (change)="changeSelectedKge(entry.idKge)"></mat-checkbox></ng-container>
            <ng-container *ngIf="column === 'KGE'">{{ entry.kge }}</ng-container>
            <ng-container *ngIf="column === 'BEZEICHNUNG'">{{ entry.bezeichnung }}</ng-container>
            <ng-container *ngIf="column === 'NUTZUNGSDAUER'">{{ entry.nutzungsdauer }}</ng-container>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColsHeaderKge"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColsKge"></tr>
</table>
<div class="ktbl-spacer-top-bottom"></div>

<h6 *ngIf="!showAllSelected">Nach der Auswahl von Gebäuden können Sie die Kostengruppen konfigurieren.</h6>

<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-button-container">
    <div class="ktbl-button-container-right">
        <button (click)="onClickUndo()" class="ktbl-button-sekundaer ktbl-button-width-m button-space" type="button">
            <i class="fas fa-undo ktbl-icon-vertical-align"></i>

            Zurücksetzen
        </button>

        <button (click)="onClickRefresh()" class="ktbl-button-primaer ktbl-button-width-m button-space" type="button">
            <i class="fas fa-sync ktbl-icon-vertical-align"></i>

            Aktualisieren
        </button>
    </div>
</div>